module.exports = __webpack_public_path__ + "img/prsnmt.6f4c729a.png";